import React from 'react';
import { Autocomplete, TextField, Box } from '@mui/material';
import { CustomImageHandler } from './CustomImageHandler';

interface Props {
    dataArray: any[];
    selected: any;
    onChange: (user: any) => void;
}

export const InfluencerSelectAutocomplete = ({ dataArray, selected, onChange }: Props) => {
    const truncate = (text: string, max: number) => {
        if (!text) return '';
        return text.length > max ? text.slice(0, max) + '...' : text;
    };
    return (
        <Autocomplete
            options={dataArray}
            value={selected || null}
            disableClearable
            isOptionEqualToValue={(option, value) => option?.id === value?.id}
            getOptionLabel={option =>
                truncate(option?.displayName || `${option?.firstName ?? ''} ${option?.lastName ?? ''}`.trim(), 25)
            }
            onChange={(e, value) => onChange(value)}
            renderOption={(props, option) => (
                <Box
                    component="li"
                    {...props}
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '10px',
                    }}
                >
                    <CustomImageHandler
                        photoPath={option?.profilePhoto?.path}
                        altTag="user"
                        classes="user-img-rounded"
                        name={option?.displayName || `${option?.firstName ?? ''} ${option?.lastName ?? ''}`}
                    />

                    <span
                        style={{
                            maxWidth: 200,
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                        }}
                    >
                        {option?.displayName || `${option?.firstName ?? ''} ${option?.lastName ?? ''}`}
                    </span>
                </Box>
            )}
            renderInput={params => {
                const value = params.inputProps.value as any;
                const selectedOption = dataArray.find(item => item?.id === selected?.id) || selected;

                return (
                    <TextField
                        {...params}
                        InputProps={{
                            ...params.InputProps,
                            startAdornment: (
                                <Box
                                    sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        mr: 1,
                                        gap: '6px',
                                    }}
                                >
                                    <CustomImageHandler
                                        thumbnailPath={selectedOption?.profilePhoto?.thumbnail}
                                        photoPath={selectedOption?.profilePhoto?.path}
                                        altTag="User Profile"
                                        classes="small-avatar"
                                        name={
                                            selectedOption?.displayName ||
                                            `${selectedOption?.firstName ?? ''} ${
                                                selectedOption?.lastName ?? ''
                                            }`.trim()
                                        }
                                    />
                                </Box>
                            ),
                        }}
                        sx={{
                            '& .MuiOutlinedInput-input': {
                                padding: '10px',
                                paddingLeft: '5px',
                                fontSize: '15px',
                                color: 'text.primary',
                                fontWeight: 400,
                            },
                        }}
                    />
                );
            }}
        />
    );
};
